import btecBnbCakeLp from "../abis/production/btecBnb/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "BTEC-BNB Cake LP",
    type: "bnb",
    contractAddress: "0x97fbF0dCc48d4E82D408D7d5f287c206125DA5D8",
    minApr: 159,
    abi: btecBnbCakeLp.abi,
    url: `${host}/0x97fbF0dCc48d4E82D408D7d5f287c206125DA5D8`,
    decimals: 18,
  },
];
